import { buildingWhite, groupWhite, hospitalWhite, toolsWhite, trafficWhite, truckWhite } from '@assets/images/pricing';

export default {
  title: 'Xem báo giá',
  link: '/vi/pricing/1',

  step1: {
    title: 'Bạn quan tâm đến ngành nào?',
    percent: '0%',
    common: 'Các trường hợp ứng dụng',
    industry: [
      {
        title: 'Xây dựng',
        example: 'Quản lý an toàn cho công nhân, quản lý vật tư, quản lý ra vào, quản lý môi trường, v.v.',
        icon: trafficWhite,
      },
      {
        title: 'Logistics',
        example: 'Quản lý kho hàng, quản lý an toàn, quản lý môi trường, quản lý ra vào, v.v.',
        icon: truckWhite,
      },
      {
        title: 'Bệnh viện',
        example: 'Quản lý ra vào, theo dõi vị trí bệnh nhân, quản lý chất thải y tế, quản lý chất lượng không khí, v.v.',
        icon: hospitalWhite,
      },
      {
        title: 'Văn phòng',
        example: 'Quản lý ra vào, quản lý tài sản, quản lý chất lượng không khí, v.v.',
        icon: buildingWhite,
      },
      {
        title: 'Sản xuất',
        example: 'Quản lý ra vào, quản lý kho hàng, quản lý chất lượng không khí, quản lý quy trình, v.v.',
        icon: toolsWhite,
      },
      {
        title: 'Khác',
        example: 'Bán lẻ, hàng không, cảng biển, phân tích lưu lượng người qua lại, quản lý bãi đỗ xe, quản lý chất lượng không khí',
        icon: groupWhite,
      },
    ],
    next: 'Tiếp theo',
  },

  step2: {
    title: 'Bạn quan tâm đến sản phẩm nào?',
    percent: '25%',
    common: 'Tìm hiểu thêm',
    product: [
      {
        title: 'Thiết bị beacon',
        example: 'Thiết bị beacon chống nước và chống bụi, được chứng minh trong môi trường công nghiệp.',
      },
      {
        title: 'Theo dõi vị trí thời gian thực',
        example: 'Gắn thẻ tag lên tài sản hoặc nhân sự để thực hiện định vị chính xác và nhanh chóng theo thời gian thực.',
      },
      {
        title: 'Theo dõi vị trí qua video',
        example: 'Theo dõi, phân tích và quản lý người hoặc phương tiện thông qua camera AI.',
      },
      {
        title: 'Hệ thống quản lý ra vào',
        example: 'Quản lý và vận hành việc ra vào tòa nhà một cách thông minh, nhanh chóng và an toàn.',
      },
      {
        title: 'Cảm biến công nghiệp',
        example: 'Giám sát điều kiện môi trường tại hiện trường như: nhiệt độ, độ ẩm, áp suất, bụi mịn, khí CO và nhiều yếu tố khác.',
      },
      {
        title: 'Digital Twin',
        example: 'Thu thập toàn bộ dữ liệu không gian để xây dựng mô hình thực tế ảo Digital Twin',
      },
    ],
    prev: 'Trước',
    next: 'Tiếp theo',
  },

  step3: {
    title: 'Vui lòng chọn các mục bên dưới',
    percent: '50%',
    question: [
      // Beacon
      {
        title: 'Mục đích sử dụng và số lượng beacon dự kiến của Quý khách là gì?',
        parts: [
          {
            title: 'Mục đích sử dụng',
            type: 'choice2',
            option: [
              { text: 'Mua sử dụng đơn lẻ' },
              { text: 'Dùng cho nghiên cứu hoặc dự án thử nghiệm' },
              { text: 'Triển khai giải pháp (Sử dụng dịch vụ)' },
              { text: 'Khác' },
            ],
          },
          {
            title: 'Số lượng dự kiến',
            type: 'choice1',
            option: [{ text: '1 ~ 1.000 chiếc' }, { text: '1.000 ~ 2.000 chiếc' }, { text: '2.000 ~ 5.000 chiếc' }, { text: 'Trên 5.000 chiếc' }],
          },
        ],
      },

      // RTLS
      {
        title: 'Độ chính xác theo dõi vị trí và diện tích địa điểm triển khai dự kiến là bao nhiêu?',
        parts: [
          {
            title: 'Độ chính xác',
            type: 'choice1',
            option: [{ text: 'Theo dõi tài sản (trong phạm vi <5m)' }, { text: 'Theo dõi chính xác cao (trong phạm vi <50cm)<50cm)' }, { text: 'Khác' }],
          },
          {
            title: 'Diện tích địa điểm',
            type: 'choice1',
            option: [{ text: '0 ~ 100 pyeong (khoảng 0 ~ 330 m2)' }, { text: '100 ~ 500 pyeong (khoảng 330 ~ 1.650 m2)' }, { text: 'Trên 500 pyeong (Trên 1.650 m2)' }, { text: 'Chưa rõ' }],
          },
        ],
      },

      // Camera
      {
        title: 'Đối tượng theo dõi và nơi lắp đặt camera ở đâu?',
        parts: [
          {
            title: 'Đối tượng theo dõi',
            type: 'choice3',
            option: [{ text: 'Con người' }, { text: 'Phương tiện' }, { text: 'Khác' }],
          },
          {
            title: 'Nơi lắp đặt',
            type: 'choice3',
            option: [{ text: 'Trong nhà' }, { text: 'Ngoài trời' }, { text: 'Chưa rõ' }],
          },
        ],
      },

      // Access
      {
        title: 'Vui lòng cho biết loại hình địa điểm và số lượng cửa ra vào',
        parts: [
          {
            title: 'Loại hình địa điểm',
            type: 'choice3',
            option: [{ text: 'Chung cư / Tòa nhà căn hộ' }, { text: 'Văn phòng và Khu thương mại/Cửa hàng' }, { text: 'Khác' }],
          },
          {
            title: 'Số lượng cửa ra vào',
            type: 'choice1',
            option: [{ text: '1 ~ 10 cửa' }, { text: '10 ~ 20 cửa' }, { text: '20 ~ 50 cửa' }, { text: 'Trên 50 cửa' }],
          },
        ],
      },

      // Industrial Sensors
      {
        title: 'Bạn cần loại cảm biến nào?',
        parts: [
          {
            title: '',
            type: 'multichoice2',
            option: [
              { text: 'Chuông báo khẩn cấp' },
              { text: 'Cảm biến báo cháy' },
              { text: 'Cảm biến nhiệt độ / độ ẩm' },
              { text: 'Cảm biến phát hiện rò rỉ nước' },
              { text: 'Cảm biến chênh lệch áp suất' },
              { text: 'Cảm biến phát hiện xâm nhập' },
              { text: 'Cảm biến chất lượng không khí' },
              { text: 'Cảm biến khí CO' },
            ],
          },
        ],
      },

      // IoT (trống)
      {
        title: '',
        parts: [
          {
            title: '',
            type: '',
            option: [{ text: '' }],
          },
        ],
      },
    ],
    prev: 'Quay lại',
    next: 'Tiếp theo',
  },

  step4: {
    title: 'Vui lòng để lại email để chúng tôi có thể liên hệ với bạn.',
    percent: '75%',
    email: 'Email',
    emailHolder: 'example@orbro.io',
    prev: 'Quay lại',
    next: 'Tiếp theo',
  },

  step5: {
    title: 'Nhân viên phụ trách sẽ liên hệ với bạn.',
    desc: 'Việc cung cấp các thông tin cần thiết sẽ giúp chúng tôi hỗ trợ bạn tốt hơn.',
    name: 'Họ tên',
    nameHolder: 'Nguyễn Văn A',
    phone: 'Số điện thoại',
    phoneHolder: '010-1234-5678',
    memo: 'Ghi chú',
    memoHolder: 'Vui lòng nhập thông tin.',
    prev: 'Nhận thông tin qua email',
    next: 'Gửi thông tin bổ sung',
  },

  step6: {
    title: 'Đã hoàn tất',
    desc: 'Chúng tôi sẽ kiểm tra và liên hệ với bạn trong thời gian sớm nhất.<br/>Nếu bạn cần được tư vấn qua điện thoại trực tiếp từ kỹ sư chuyên môn, vui lòng đặt lịch hẹn.',
    btn: 'Đặt lịch tư vấn qua điện thoại',
  },

  schedule: {
    title: 'Vui lòng nhập thời gian có thể gọi.',
    company: 'Đơn vị',
    companyHolder: 'ORBRO',
    name: 'Họ tên',
    nameHolder: 'Nguyễn Văn A',
    date: 'Ngày',
    time: 'Thời gian',
    submit: 'Gửi',
    morning: 'Sáng',
    noon: 'Chiều',
  },
};
